import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { motion } from 'framer-motion'

export const ContentIcon = styled(Link)`
    width: 28.67px;
    height: 28.67px;
`
export const Logo = styled(motion.img)`
    width: 100%;
    height: 100%;
`
